<template>
  <div>
    <div v-if="!showScore">
      <Questions
        :questions="questions"
        :currentQuestion="currentQuestion"
        @emitToParent="handleAnswerClick"
      ></Questions>
    </div>
    <div v-else>
      <Scores :scores="scores" :categories="categories"></Scores>
    </div>
  </div>
</template>

<script>
import Scores from "./components/Scores";
import Questions from "./components/Questions";

// Data files
import questions from "./data/questions";
import categories from "./data/categories";

export default {
  components: {
    Scores,
    Questions
  },

  data() {
    return {
      currentQuestion: 0,
      showScore: false,
      sortedCategories: [],
      scores: [],

      // from data files
      categories: categories,
      questions: questions
    };
  },

  methods: {
    // Initialize the score array where all scores = 0
    initScores() {
      this.categories.forEach((item, index) => {
        this.scores[index] = {
          code: item.code,
          score: 0
        };
      });
    },
    handleAnswerClick(categoryCode) {
      let nextQuestion = this.currentQuestion + 1;

      // Update the score
      let arrayIndex = this.scores.findIndex(item => item.code == categoryCode);
      let oldScore = this.scores[arrayIndex].score;
      this.$set(this.scores[arrayIndex], "score", oldScore + 1);

      if (nextQuestion < this.questions.length) {
        this.currentQuestion = nextQuestion;
      } else {
        this.showScore = true;
      }
    }
  },
  created() {
    this.initScores();
  }
};
</script>

<style scoped>
button:hover {
  cursor: pointer;
}

.answer-section {
  display: flex;
  flex-direction: column;
}

.answer-section {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 60%;
}

.answer-section .answer-wrapper {
  display: flex;
  flex-direction: column;
  width: 33.33%;
}

img.answer-img {
  background-color: #efefef;
  border: 1px solid #cccccc;
  display: inline-block;
  height: auto;
  width: 100%;
}

.answer-section:hover {
  cursor: pointer;
}
</style>
